import { useState } from 'react'

import { type ProspectDto } from '@api'
import { pdf } from '@react-pdf/renderer'

import { handleError } from '@/utils/error'

import { useAuditProspect } from '../../hooks/use-audit-prospect'
import { PdfReport } from '../pdf-report/PdfReport'
import { formatProspectAudit } from './utils'

interface Props {
  prospect: ProspectDto
}

export const useExportAudit = ({ prospect }: Props) => {
  const { auditProspect } = useAuditProspect()
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async () => {
    if (isExporting) return

    try {
      setIsExporting(true)
      const data = await auditProspect(prospect.id!)
      const formatted = await formatProspectAudit(data)

      const MyPDFDocument = <PdfReport data={formatted} />

      const pdfBlob = await pdf(MyPDFDocument).toBlob()

      const link = document.createElement('a')

      link.href = URL.createObjectURL(pdfBlob)
      link.download = `Prospect Report - ${prospect.name}.pdf`
      link.click()
    } catch (error) {
      handleError(error, 'Failed to export audit')
    } finally {
      setIsExporting(false)
    }
  }

  return {
    onExport: handleExport,
    isExporting,
  }
}
